<template>
  <div class="page">
    <div class="page-title">
      <h4>权限管理</h4>
    </div>
    <el-row :gutter="24">
      <el-col :span="8">
        <div class="treeDiv">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText"
            size="small"
            class="filter"
          ></el-input>
          <el-tree
            :data="data"
            node-key="id"
            :props="defaultProps"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            ref="tree"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ data.menu_name }}</span>
              <span>
                <el-button-group>
                  <el-button
                    icon="el-icon-circle-plus"
                    size="mini"
                    @click="() => append(data)"
                  ></el-button>
                  <el-button
                    icon="el-icon-edit"
                    size="mini"
                    @click="() => edit(node, data)"
                  ></el-button>
                  <el-button
                    icon="el-icon-delete"
                    size="mini"
                    @click="() => remove(node, data)"
                  ></el-button>
                </el-button-group>
              </span>
            </span>
          </el-tree>
        </div>
      </el-col>

      <el-col :span="16">
        <div class="grid-content bg-purple">
          <ele-form
            :isShowBackBtn="false"
            :isShowCancelBtn="false"
            :isResponsive="false"
            :span="18"
            isShowResetBtn
            @reset="handleRest"
            labelPosition="left"
            formBtnSize="small"
            :formDesc="formDesc"
            v-model="formData"
            :options-fn="http.get"
            :request-fn="handleSubmit"
            @request-success="handleSuccess"
            :submitBtnText="submitBtnText"
          ></ele-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  deleteMenu,
  updataMenu,
  addMenu,
  getMenuList
} from "@/api/menu/menu.js";
export default {
  name: "role-list",
  components: {},
  created() {
    this.getTreeList();
  },
  data: function() {
    return {
      submitBtnText: "新增",
      filterText: "",
      data: [],
      formData: {},
      formDesc: {
        parent_id: {
          options: "/api/menu/handle_tree",
          label: "上级菜单",
          type: "tree-select",
          // type: "cascader",
          // prop: {
          //   text: "menu_name",
          //   id: "menu_id"
          // },
          attrs: {
            size: "small",
            showAllLevels: false
          }
        },
        menu_name: {
          label: "菜单名称",
          type: "input",
          attrs: {
            size: "small"
          },
          required: true
        },
        icon: {
          type: "selectIcon",
          label: "图标筛选",
          attrs: {
            name: "url"
          }
          // label: "菜单图标",
          // type: "input",
          // attrs: {
          //   size: "small"
          // }
        },
        url: {
          label: "页面路径",
          type: "input",
          attrs: {
            size: "small"
          },
          required: true
        },
        order_num: {
          label: "排序",
          type: "input",
          attrs: {
            size: "small",
            type: "number"
          },
          layout: 8,
          default: 0,
          tip: "数字越小越靠前"
        },
        router: {
          type: "input",
          label: "请求地址"
        },
        target: {
          label: "打开方式",
          type: "radio",
          attrs: {
            size: "small"
          },
          // （menuItem页签 menuBlank新窗口）"
          options: [
            {
              text: "页签",
              value: "menuItem"
            },
            {
              text: "新窗口",
              value: "menuBlank"
            }
          ]
        },
        visible: {
          label: "菜单状态",
          type: "radio",
          attrs: {
            size: "small"
          },
          options: [
            {
              text: "显示",
              value: 0
            },
            {
              text: "隐藏",
              value: 1
            }
          ]
        },
        menu_type: {
          options: [
            {
              text: "页面",
              value: "C"
            },
            {
              text: "按钮",
              value: "F"
            },
            {
              text: "菜单",
              value: "M"
            }
          ],
          label: "页面类型",
          type: "radio",
          attrs: {
            size: "small"
          },
          // layout: 10,
          default: 1
        },
        remark: {
          label: "备注",
          type: "input",
          attrs: {
            size: "small"
          }
        },
        // defaultProps: {
        //   children: "children",
        //   label: "label"
        // },

        // submittype: 0
      }
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    handleRest() {
      this.submittype = 0;
      this.formData = {};
      this.submitBtnText = "新增";
    },
    append(data) {
      const newChild = {
        menu_id: 0,
        id: 0,
        parent_id: data.id,
        scenario: data.scenario,
        display_name: "新增菜单",
        label: "新增菜单",
        subtitle: "", 
        sorting: 0,
        type: 1,
        children: []
      };
      if (!data.children) {
        this.$set(data, "children", []);
      }
      this.formData = newChild;
      data.children.push(newChild);
    },
    edit(node, data) {
      this.submitBtnText = "修改";
      this.submittype = 1;
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      data.name = data.label;
      this.formData = data;
    },
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.menu_id);
      if (data.menu_id > 0) {
        let postData = {
          menu_id: data.menu_id
        };
        deleteMenu
          .r({
            menu_id: data.menu_id
          })
          .then(res => {
            children.splice(index, 1);
            this.$message.success("菜单删除成功~");
          })
          .catch(e => {});
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleSubmit(data) {
      return Promise.resolve();
    },
    handleSuccess() {
      let data = this.formData;
      // this.submittype
      if (this.submitBtnText == "新增") {
        addMenu.r(data).then(res => {
          this.formData = {
            scenario: "admin",
            sorting: 0,
            type: 1
          };
          this.$message.success("菜单《" + res.name + "》添加成功");
          this.getTreeList();
        });
      } else {
        updataMenu.r(data).then(res => {
          this.formData = {
            scenario: "admin",
            sorting: 0,
            type: 1
          };
          this.$message.success("菜单《" + data.name + "》修改成功");
          this.getTreeList();
          this.submittype = 0;
        });
      }
    },
    getTreeList() {
      getMenuList.r().then(res => {
        this.data = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// .page {
//   // overflow-y:scroll;
// }
.treeDiv {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  height: calc(100vh - 150px);
  overflow: scroll;
  border-right: 1px #ebeef5 dotted;
  padding-right: 30px;
}
.grid-content {
  height: calc(100vh - 150px);
  overflow: scroll;
}
.filter {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  z-index: 2;
  margin-bottom: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.el-button--mini,
.el-button--mini.is-round {
  padding: 2px;
}

.xvue-crud {
  th {
    word-break: break-word;
    color: rgba(0, 0, 0, 0.85);
    background-color: #fafafa;
  }

  .el-dialog {
    text-align: left;
  }

  .formD {
    text-align: left;
  }
}
</style>
